import { render, staticRenderFns } from "./hotline.vue?vue&type=template&id=36c06ac8&scoped=true&"
import script from "./hotline.vue?vue&type=script&lang=js&"
export * from "./hotline.vue?vue&type=script&lang=js&"
import style0 from "./hotline.vue?vue&type=style&index=0&id=36c06ac8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c06ac8",
  null
  
)

export default component.exports